import React, { useEffect } from 'react';
import { usePDF, Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import ToggleButton from '@mui/material/ToggleButton';

import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import Logo from '../../assets/images/erColor.png';
import Fuente from '../../assets/fonts/open-sans.ttf';

Font.register({
    family: 'Open Sans',
    src: Fuente
});

// Create styles
const styles = StyleSheet.create({
    page: {
        margin: '0cm 0cm',
    },
    section: {
        margin: '1cm 1cm 1cm',
    },
    header: {
        position: 'fixed',
        top: '0cm',
        left: '0cm',
        right: '0cm',
        height: '2cm',
        paddingLeft: '30px',
        paddingRight: '30px',
       // marginBottom: '10px',
        border: '3px solid black',
    },
    recuadro: {
        border: '1px solid black',
        padding: '10px',
      //  marginBottom: '1em'
    },

    texto: {
        fontSize: '9px',
    },
    texto_fecha: {
        fontSize: '11px',
        textAlign: 'right',
        marginTop: '10px',
        color: 'grey',
    },
    texto_fecha_recuadro: {
        fontSize: '11px',
        textAlign: 'center',
        marginTop: '10px',
        color: 'grey',
    },
    texto_negrita: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    texto_oyd: {
        fontSize: 11,
        fontWeight: 'bold'
    },
    texto_negrita_encabezado: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '-20px',
        textTransform: 'uppercase'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    pageNumber2: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 30,
        textAlign: 'right',
        color: 'grey',
    },

    table: {
        width: '100%',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: 8,
        marginLeft: '1cm',
        marginRight: '1cm'
    },
    headert: {
        borderTop: 'none',
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center'
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    row1: {
        width: '10%',
        textAlign: 'center'
    },
    row2: {
        width: '30%',
        textAlign: 'left'
    },
    row3: {
        width: '10%',
        textAlign: 'center'
    },
    row4: {
        width: '10%',
        textAlign: 'center'
    },
    row5: {
        width: '40%',
        textAlign: 'center'
    },
    row1d: {
        width: '10%',
        textAlign: 'center'
    },
    row2d: {
        width: '30%',
        textAlign: 'left'
    },
    row3d: {
        width: '10%',
        textAlign: 'center'
    },
    row4d: {
        width: '10%',
        textAlign: 'center'
    },
    row5d: {
        width: '40%',
        textAlign: 'left'
    },
    footer: {
      margin: '1cm',
    }
});
var today = new Date(),
    dateNow = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

const Documento = (props) => (
    <Document>
        <Page size="A4" style={styles.page} orientation='landscape'>
            <View style={styles.section} fixed>
                <View style={styles.header}>
                    <Image
                        style={{ marginLeft: '10px', width: '4cm', marginTop: '10px' }}
                        src={Logo}
                    />
                        <Text style={styles.texto_negrita_encabezado}>LISTADO DE EXPEDIENTES A SEGUIR</Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, styles.bold, styles.headert]} fixed>
                    <Text style={styles.row1}>Expediente</Text> 
                    <Text style={styles.row2}>Asunto</Text>
                    <Text style={styles.row3}>Soporte</Text>
                    <Text style={styles.row4}>Folios</Text>
                    <Text style={styles.row5}>Situación</Text>
                </View>
                {props.datos.map((dato, indice) => (
                    <View key={indice} style={styles.row} wrap={false}>
                        <Text style={styles.texto, styles.row1d}>{dato.numero}</Text> 
                        <Text style={styles.texto, styles.row2d}>{dato.asunto}</Text>
                        <Text style={styles.texto, styles.row3d}>{dato.soporte}</Text>
                        <Text style={styles.texto, styles.row4d}>{dato.folios}</Text>
                        <Text style={styles.texto, styles.row5d}>{dato.situacion}</Text>
                    </View>
                ))}
            </View>
            <View style={styles.footer} fixed>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages}`
                )} />
                <Text style={styles.pageNumber2} render={({ pageNumber, totalPages }) => (
                    `Impresión ${dateNow}`
                )} />
            </View>
        </Page>

    </Document>
);

const ReporteSeguidos = (props) => {
    const [instance, updateInstance] = usePDF({ document: <Documento datos={props.datos} /> });

    useEffect(() => {
        if (!instance.loading && props.datos.length !== 0 && props.datos.length <= 300) {
            window.open(instance.url, '', 'toolbar=yes, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=900, top=10');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance.loading])

    return (
        <ToggleButton
            value="imprimir"
            title="Imprimir listado"
            disabled={(props.datos.length === 0 || props.datos.length > 300) || instance.loading}
            onClick={updateInstance}
            sx={{ border: 0, "&.Mui-disabled": { border: 0, },padding:0.8 }}
        >
            <PrintOutlinedIcon />
        </ToggleButton>
    );
};

export default ReporteSeguidos;